import { useEffect, useState } from 'react'

export const useImage = ({ fileName, extensions = ['png'] }) => {
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(null)
  const [image, setImage] = useState(null)

  const fetchImage = async (fileExtensions) => {
    if (fileExtensions.length === 0) {
      setError(new Error('No se encontró la imagen con las extensiones proporcionadas.'))
      setLoading(false);
      return;
    }

    try {
      const ext = fileExtensions.shift()
      const response = await import(`src/assets/aerolineas/${fileName}.${ext}`)
      setImage(response.default)
      setLoading(false)
    } catch (err) {
      fetchImage(fileExtensions) // Solo sigue intentando si queda alguna extensión
    }
  }
 
  useEffect(() => {
    fetchImage([...extensions])
  }, [fileName])

  return {
    loading,
    error,
    image,
  }
}
